/**
 * indexMachine.ts
 * Item 6.1 (qa/index-tests-2026-07-23/INDEX-ACTION-PLAN.md) — the one shared
 * predicate for "is this the virtual pooled Index machine row" (Code 'INDEX',
 * seeded by migration 112 / I5-I6). Every view that needs to special-case the
 * Index row (Machine Schedule today; Master Gantt at Item 6.2) should import
 * this instead of re-testing the literal string, so the identity check never
 * drifts between views.
 */

/** `Machine.Code` of the seeded virtual Index-tests machine (migration 112). */
export const INDEX_MACHINE_CODE = 'INDEX';

/** True when `code` is the virtual pooled Index machine's Code. */
export function isIndexMachineCode(code: string | null | undefined): boolean {
  return code === INDEX_MACHINE_CODE;
}
